import React from "react";
import styled from "styled-components";
import ActivityIndicator from "./ActivityIndicator";
interface Props {
  loading?: boolean;
  size?: "sm" | "md" | "lg";
}

const Spin: React.FC<Props> = (props) => {
  const { loading, children, size = "md" } = props;
  if (!loading) return <>{children}</>;
  return (
    <Container>
      <ActivityIndicator size={size} loading={loading} />
      {children}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background: transparent;
  height: 100%;
`;

export default Spin;
